import {javaApiFor} from 'sources/api';
import {List} from 'immutable';
import moment from 'moment';
import {FetchUserTableResponse, UserAdminSortFields} from '@store/@types/UserAdmin';
import {SortDirection} from 'utils/const';
import {Int} from '@store/@types/util';
import {TeamId} from 'records/TeamId';
import {DepartmentId} from 'records/Department';
import {UserId} from 'records/User';

const api = javaApiFor('/api/admin/users');

export interface FetchUserTableParams {
  sort?: UserAdminSortFields;
  sortDirection?: SortDirection;
  offset?: Int;
  limit?: Int;
  includeInactive?: boolean;
  search?: string;
  teamId?: TeamId;
  departmentId?: DepartmentId;
}

export interface UpdateUserTeamParams {
  userId: UserId;
  teamId: TeamId;
}

export interface UpdateUserActiveParams {
  userId: UserId;
  active: boolean;
}

export class AdminUserSource {
  static fetchUserTable(params: FetchUserTableParams = {}): Promise<FetchUserTableResponse> {
    return api
      .postJson<FetchUserTableParams, FetchUserTableResponse>('/search', params)
      .then(res => ({
        ...res,
        users: List(
          res.users.map(u => ({...u, lastLogin: u.lastLogin ? moment(u.lastLogin) : undefined}))
        ),
      }));
  }

  static setUserTeam({teamId, userId}: UpdateUserTeamParams): Promise<void> {
    return api.postJson(`/${userId}/set-team`, {teamId});
  }

  static setUserActive({userId, active}: UpdateUserActiveParams): Promise<void> {
    return api.postJson(`/${userId}/set-active`, {active});
  }
}
